export default __webpack_public_path__ + "static/media/icon-money.f6713eed.svg";